/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BuildingHomeIcon16Light = forwardRef('BuildingHomeIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6.232 3.225a2.5 2.5 0 0 1 3.536 0l4.878 4.879a.5.5 0 0 0 .708-.708l-4.88-4.878a3.5 3.5 0 0 0-4.949 0L.646 7.396a.5.5 0 0 0 .708.708l4.878-4.88Z" }),
        React.createElement("path", { d: "M4 8.5a.5.5 0 0 0-1 0v4A2.5 2.5 0 0 0 5.5 15h5a2.5 2.5 0 0 0 2.5-2.5v-4a.5.5 0 0 0-1 0v4a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 4 12.5v-4Z" })));
});
